// extracted by mini-css-extract-plugin
export default {"tabsContainer":"style_tabsContainer__5hYfI","tabs":"style_tabs__JSV7q","tabItem":"style_tabItem__6VIMr","tabActive":"style_tabActive__SrGma"};